import { GetterTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";

const korfineGetters: GetterTree<IPropertyEditState, {}> = <GetterTree<IPropertyEditState, {}>>{
    service: (state: IPropertyEditState) => state.service,
    korfine: (state: IPropertyEditState) => state.korfine,
    contract: (state: IPropertyEditState) => state.korfine.Contract,
    owner: (state: IPropertyEditState) => state.korfine.Contract.Owner,
    estate: (state: IPropertyEditState) => state.korfine.Contract.Estate,
    tenant: (state: IPropertyEditState) => state.korfine.Contract.Tenant,
}
export default korfineGetters;